/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".host_16240177{display:inline-block}\n"}]);
export const host = "host_16240177";